export class Property
{
	propertyId: number;
	propertyDate: Date;
}
